/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MessagingChannelBasic { 
    /**
     * Name that identifies particular messaging platform in use
     */
    service_name: string;
    /**
     * Identity of the channel in external messaging platform, is required for client SDKs
     */
    channel_external_id: string;
    /**
     * True value indicates if current user has permission to send the messages to this channel
     */
    readonly: boolean;
}